import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { Filter } from 'lucide-react';

interface CostsTypeFilterProps {
  providers: string[];
  selectedType: string;
  onTypeChange: (type: string) => void;
}

export function CostsTypeFilter({ providers, selectedType, onTypeChange }: CostsTypeFilterProps) {
  useLanguage();
  if (providers.length === 0) return null;

  return (
    <div className="bg-white border border-slate-100 rounded-2xl p-4 shadow-sm">
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-1.5">
          <Filter size={14} className="text-slate-400" />
          <span className="text-[11px] text-slate-400 font-bold uppercase tracking-wider">{translateInterfaceText("Filtrar por Provedor")}</span>
        </div>
        <select
          value={selectedType}
          onChange={(e) => onTypeChange(e.target.value)}
          className="text-xs font-medium text-slate-700 bg-slate-50 border border-slate-200 rounded-lg px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent cursor-pointer hover:bg-slate-100 transition-colors"
        >
          <option value="todos">{translateInterfaceText("Todos")}</option>
          {providers.map((provider) => (
            <option key={provider} value={provider}>
              {provider}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export default CostsTypeFilter;
